import { Page } from 'components/Page'
import { Stack } from '@mui/material'
import { DashBoardHeader } from './DashBoard/DashBoardHeader'
import { useCurrentCorporateAccountStore } from 'stores/useCurrentCorporateAccountStore'
import { EmptyStateHomePage } from './EmptyStateHomePage'
import { colorPrimitives } from 'components/Theme'
import { useGetEULA } from 'hooks/api/Settings/useGetEULA'
import { useEffect, useState } from 'react'
import { usePutEULAAcceptedDate } from 'hooks/api/Settings/usePutEULAAcceptedDate'
import { EULADialog } from 'pages/Login/CreateAccount/EULADialog'
import { AccountManager } from 'pages/Home/AccountManager'
import { AccountManagerMobile } from 'pages/Home/AccountManagerMobile'
import { useLayout } from 'hooks/useLayout'
import { LicensesLicensedEstablishment } from './LicensesLicensedEstablishment/LicensesLicensedEstablishment'
import { useSetMe } from 'stores/useMeQuery'
import { useEULAAcceptedDate } from 'stores/useEULAAcceptedDate'
import { useGetFeatureAccess } from 'hooks/api/FeatureAccess/useGetFeatureAccess'
import { setFeatureAccess } from 'utils/setFeatureAccess'

export const HomePage = () => {
  const { passedMe } = useSetMe()
  const meQuery = passedMe
  const { isMobile } = useLayout()
  const selectedCorporateAccount = useCurrentCorporateAccountStore()
  const { acceptedDate } = useEULAAcceptedDate()

  const hasNoAccess =
    !meQuery.data?.corporateAccounts ||
    meQuery.data?.corporateAccounts.length === 0

  const featureAccessQuery = useGetFeatureAccess({
    currentStateId: 1, // TODO: Update to use actual state ID when available
    enabled: !!meQuery.data,
  })

  const handleContactClick = () => {
    const url = 'https://www.jjgaming.com/contact/'
    window.open(url, '_blank')
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const toggleModalIsOpen = () => {
    setIsModalOpen(!isModalOpen)
  }

  const saveEULAAcceptedDate = () => {
    mutation.mutate()
    toggleModalIsOpen()
  }

  const mutation = usePutEULAAcceptedDate({
    onError: () => {},
    onSuccess: () => {},
  })

  const settingsEULAQuery = useGetEULA()

  let isEULAUpdated = false

  useEffect(() => {
    if (meQuery.data && featureAccessQuery.data) {
      setFeatureAccess(featureAccessQuery.data)
    }
  }, [meQuery.data, featureAccessQuery.data])

  useEffect(() => {
    const settingEULA = settingsEULAQuery.data

    const eulaLastModifiedDateTime = settingEULA?.lastModified
    let eulaAcceptedDateTime = meQuery.data?.user?.eulaAccepted

    if (eulaLastModifiedDateTime !== undefined) {
      // Check if the eulaAcceptedDateTime value is available
      // If not, a new user is being created so the eulaAcceptedDateTime will not be available because we are using the shared ME data which has already been populated
      // In this case, just set the eulaAcceptedDateTime from the acceptedDate store (the acceptedDate is set when a new user is created and the user clicks on the 'I've read and accept the End-User-License Agreement (EULA).' checkbox)
      if (eulaAcceptedDateTime === null || eulaAcceptedDateTime === undefined) {
        eulaAcceptedDateTime = acceptedDate
      }

      if (eulaAcceptedDateTime !== null && eulaAcceptedDateTime !== undefined) {
        isEULAUpdated = eulaAcceptedDateTime < eulaLastModifiedDateTime
      }

      if (
        eulaAcceptedDateTime === null ||
        eulaAcceptedDateTime === undefined ||
        eulaAcceptedDateTime < eulaLastModifiedDateTime
      ) {
        toggleModalIsOpen()
      }
    }
  }, [])

  return (
    <Page
      px={0}
      pt={0}
      pb={0}
      header={
        <DashBoardHeader
          corporateAccountId={
            selectedCorporateAccount.currentCorporateAccountId
          }
          corporateAccountName={
            selectedCorporateAccount.currentCorporateAccountName
          }
        />
      }
    >
      <Stack
        className="h-screen"
        sx={{ backgroundColor: colorPrimitives.lightGray }}
      >
        {hasNoAccess || !selectedCorporateAccount.currentCorporateAccountId ? (
          <EmptyStateHomePage onContactClick={handleContactClick} />
        ) : (
          <LicensesLicensedEstablishment />
        )}
      </Stack>
      <EULADialog
        showEULAUpdatedLabel={!isEULAUpdated}
        showAcceptButton={true}
        showCancelButton={false}
        isModalOpen={isModalOpen}
        onConfirm={saveEULAAcceptedDate}
        onClose={() => {}}
      />
      {selectedCorporateAccount.currentCorporateAccountId &&
        (isMobile ? <AccountManagerMobile /> : <AccountManager />)}
    </Page>
  )
}
